export const enhanceUploadsWithDataNormalization = (uploads = []) => {
    const normalizedUploads = uploads.map(upload => {
        return {
            ...upload,
            title: upload.photoTitle,
            description: upload.photoDescription,
            location: upload.photoLocation,
            batchId: upload.photoBatchId
        };
    });

    return normalizedUploads;
};

/**
 * enhanceUploadsWithModTags: Gets Photo Upload Tags in their various states , approved, warnings
 * @param {Array} selectedUploads array of selected photo uploads
 * @returns {Array} of objects that includes new modTags {Array} prop of tagObjects
 *
 * Note: `userTags`, `approvedUserTags`, and `warningUserTags` are all arrays of string names
 * need to add prop tagObjects that converts strings to objects which include { name: "value", hasWarning: true, }
 */
const enhanceUploadsWithModTags = (uploads = []) => {
    const enhancedUploads = uploads.map(upload => {
        const { userTags, approvedUserTags, warningUserTags } = upload;
        let incr = 1;
        return {
            ...upload,
            modTags: userTags.map(ut => {
                const id = incr;
                incr++;
                return {
                    id,
                    name: ut,
                    isApproved: !!approvedUserTags.find(aut => aut === ut),
                    hasWarning: !!warningUserTags.find(wut => wut === ut)
                };
            })
        };
    });

    return enhancedUploads;
};

export const enhanceUploads = (uploads = [], uploadsState = {}) => {
    if (!Array.isArray(uploads)) {
        return console.warn("Please pass array of uploads to enhanceUploads");
    }

    let enhancedUploads = uploads.map(upload => ({
        ...uploadsState[upload.id],
        ...upload
    }));

    enhancedUploads = enhanceUploadsWithDataNormalization(enhancedUploads);
    enhancedUploads = enhanceUploadsWithModTags(enhancedUploads);

    return enhancedUploads;
};
